import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bodyAreas, productName, showcaseFeatures } from '../data/content';
import { Eyebrow } from './ui/Section';
export function ProductShowcase() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-227" data-mp="32lkybzr0zrgz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-228" data-mp="32n5utuwwhkhh">
        <Eyebrow data-id="element-229" data-mp="2xn9se03uq141">The complete 5-volume rehabilitation system</Eyebrow>
        <h2 className="text-2xl font-black uppercase leading-tight text-teal-950 md:text-3xl" data-id="element-230" data-mp="29w49td6j0uq1">{productName}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-231" data-mp="24ycjgnlj5gny">
          Practical resources for physical therapists, physiotherapists, and geriatric rehabilitation professionals.
        </p>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-2 gap-y-1 text-xs font-bold uppercase tracking-wide text-teal-700" data-id="element-232" data-mp="2eufkfq4nb99b">
          {bodyAreas.map((area, index) => <li key={area} className="flex items-center gap-2" data-id="element-233" data-mp="3qa47siltaaan" data-mpi={index}>
              {index > 0 && <span className="text-teal-800/30" aria-hidden="true" data-id="element-234" data-mp="249e1joxco0wl">
                  •
                </span>}
              {area}
            </li>)}
        </ul>

        <h3 className="mt-8 text-sm font-black uppercase tracking-wider text-teal-950" data-id="element-235" data-mp="2e9enzjqimx50">Inside the system:</h3>
        <ul className="mt-4 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-236" data-mp="2i8niwrxal125">
          {showcaseFeatures.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-teal-800/10 bg-white px-4 py-2.5 text-sm font-semibold text-teal-950" data-id="element-237" data-mp="1llitmlof5hbe">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-800" data-id="element-238" data-mp="1uj2xm2do1rpp">
                <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-239" data-mp="1zd75qoyo45sd" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}